module.exports = __webpack_public_path__ + "static/media/image8.80bc7f10.JPG";